import Order from './Order';
import My from './My';
import Message from './Message'; // 消息中心相关
import News from './News';
import Register from './Register' //挂号
import Pay from './Pay' //支付
export default class PMA {
  constructor(config) {
    this.config = config;
    this.my = new My(this.config);
    this.news = new News(this.config);
    this.message = new Message(this.config);
    this.order = new Order(this.config);
    this.register = new Register(this.config);
    this.pay = new Pay(this.config);
  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/index.js